import whatsAppIcon from '/asset/whatsApp_white.svg';

interface WhatsAppChatButtonProps {
  phoneNumber?: string | null;
}

export default function WhatsAppChatButton({
  phoneNumber,
}: WhatsAppChatButtonProps) {
  const normalizedNumber = phoneNumber?.replace(/\D/g, '');

  if (!normalizedNumber) {
    return null;
  }

  return (
    <div
      className="
    py-3
    flex
    flex-row-reverse
    px-4
    absolute
    top-[-80px]
    right-[0px]
    "
    >
      <a
        href={`https://wa.me/${normalizedNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        title="Chat on WhatsApp"
        className="z-[400]
          flex h-[56px] w-[56px] items-center justify-center rounded-full
          bg-[#25D366] shadow-lg shadow-black/20 transition
          hover:bg-[#1ebe5d] focus:outline-none focus:ring-4 focus:ring-[#25D366]/30
          md:h-[60px] md:w-[60px]"
      >
        <img src={whatsAppIcon} alt="" className="h-[28px] w-[28px]" />
      </a>
    </div>
  );
}
